var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelieveryBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.8012,
    height: 37.8012,
    rx: 18.9006,
    fill: "#E86A0D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_5196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8558 11.5879H10.043V21.8257H21.8558V11.5879Z",
    stroke: "white",
    strokeWidth: 1.57505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8555 15.5264H25.0056L27.3681 17.8889V21.8266H21.8555V15.5264Z",
    stroke: "white",
    strokeWidth: 1.57505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5899 25.7629C14.6773 25.7629 15.5587 24.8815 15.5587 23.7941C15.5587 22.7068 14.6773 21.8253 13.5899 21.8253C12.5026 21.8253 11.6211 22.7068 11.6211 23.7941C11.6211 24.8815 12.5026 25.7629 13.5899 25.7629Z",
    stroke: "white",
    strokeWidth: 1.57505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8243 25.7629C24.9116 25.7629 25.7931 24.8815 25.7931 23.7941C25.7931 22.7068 24.9116 21.8253 23.8243 21.8253C22.7369 21.8253 21.8555 22.7068 21.8555 23.7941C21.8555 24.8815 22.7369 25.7629 23.8243 25.7629Z",
    stroke: "white",
    strokeWidth: 1.57505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_5196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9006,
    height: 18.9006,
    fill: "white",
    transform: "translate(9.25781 9.22461)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelieveryBus);
export default __webpack_public_path__ + "static/media/delieveryBus.b6b138f79e990c33a0ad8fb28a982e2f.svg";
export { ForwardRef as ReactComponent };